module.exports = __webpack_public_path__ + "static/dog-s-gray-c7ed417fba22ab70135ed1687043fddf.jpg";